(function(){
  /* "Dress for the night" rail on the events page (sections/main-events.liquid) uses its own
     hand-rolled .pcard/.qa-bar quick-add, separate from the sitewide .pc/.qa[data-qa] component.
     The first pass here only ever exposed ONE variant dimension as plain-text chips (whichever
     option wasn't named "Color"), so a product with both Color and Size only ever showed one of
     them, and colors rendered as plain text pills instead of the swatch-chip style used
     everywhere else on the site. This rebuild mirrors the exact guided step-through flow from
     theme.js's qaRender (color swatches first when present, then size, with a back button),
     reusing window.YG.swatchColor/isColorOptionName so it looks and behaves identically to every
     other quick-add on the site.

     NOTE: /products/{handle}.js returns `options` as an array of OBJECTS ({name,position,values}),
     not plain strings -- the first pass assumed strings, which silently broke the color/swatch
     detection (comparing "[object Object]" against the color-name regex) without ever throwing,
     so it looked like it "worked" but only ever rendered the plain-text fallback. optNames below
     normalizes both shapes defensively. */
  function isColorOptionName(n){ return /^colou?r$/i.test(String(n||'').trim()); }
  function swatchColor(name){
    if(window.YG && typeof window.YG.swatchColor === 'function') return window.YG.swatchColor(name);
    return name;
  }
  function optionName(o){ return (o && typeof o === 'object') ? o.name : o; }

  function ensureStyle(){
    if(document.getElementById('yg-dress-qa-style')) return;
    var css = '.pcard .qa-step{display:inline-flex;align-items:center;gap:6px;background:rgba(246,242,234,.97);border-radius:40px;padding:6px 10px 6px 6px;box-shadow:0 6px 20px rgba(60,50,30,.16);max-width:100%;text-align:left}'+
      '.pcard .qa-back{flex:0 0 auto;background:none;border:0;font-size:15px;line-height:1;color:#8a8272;cursor:pointer;padding:4px 2px}'+
      '.pcard .qa-back[hidden]{display:none}'+
      '.pcard .qa-lab{flex:0 0 auto;font-size:9.5px;letter-spacing:.16em;text-transform:uppercase;color:#9a927f;white-space:nowrap}'+
      '.pcard .qa-chips{display:flex;align-items:center;gap:4px;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x proximity;scrollbar-width:none;-webkit-overflow-scrolling:touch;flex:1;padding:5px 3px}'+
      '.pcard .qa-chips::-webkit-scrollbar{display:none}'+
      '.pcard .qa-chip{flex:0 0 auto;scroll-snap-align:start;min-width:28px;text-align:center;font-size:10px;padding:7px 10px;border-radius:30px;cursor:pointer;color:#20201d;transition:.15s;border:0;background:rgba(32,32,29,.05)}'+
      '.pcard .qa-chip:hover:not(:disabled){background:#20201d;color:#f6f2ea}'+
      '.pcard .qa-chip:disabled{opacity:.3;cursor:not-allowed;text-decoration:line-through}'+
      '.pcard .qa-chip.sw{min-width:0;width:19px;height:19px;padding:0;border-radius:50%;border:1px solid rgba(0,0,0,.18);outline:2px solid transparent;outline-offset:1px;flex:0 0 auto}'+
      '.pcard .qa-chip.sw:hover:not(:disabled){transform:scale(1.08)}'+
      '.pcard .qa-chip.sw:disabled{text-decoration:none;position:relative}'+
      '.pcard .qa-chip.sw:disabled::after{content:"";position:absolute;inset:-1px;border-radius:50%;background:linear-gradient(to top right,transparent 46%,rgba(120,20,10,.55) 48%,rgba(120,20,10,.55) 52%,transparent 54%)}'+
      '.pcard .qa-btn{width:100%;background:rgba(246,242,234,.96);border:0;border-radius:40px;padding:12px;font-family:inherit;font-size:10.5px;letter-spacing:.18em;text-transform:uppercase;color:#20201d;cursor:pointer;box-shadow:0 6px 20px rgba(60,50,30,.14);transition:.2s}'+
      '.pcard .qa-btn:hover{background:#20201d;color:#f6f2ea}'+
      '.pcard .qa-done{display:none;text-align:center;background:#20201d;color:#f6f2ea;border-radius:40px;padding:12px;font-size:10.5px;letter-spacing:.16em;text-transform:uppercase}'+
      '.pcard .qa.done .qa-bar,.pcard .qa.done .qa-step{display:none}'+
      '.pcard .qa.done .qa-done{display:block}';
    var s = document.createElement('style');
    s.id = 'yg-dress-qa-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function buildChosenBase(opts, steps, variants){
    var chosen = new Array(opts.length).fill(null);
    for(var i=0;i<opts.length;i++){
      if(steps.indexOf(i) < 0){ chosen[i] = variants.length ? variants[0].o[i] : null; }
    }
    return chosen;
  }

  function render(qa){
    var data = qa._d, ptr = qa._ptr, chosen = qa._chosen;
    var gi = data.steps[ptr];
    var chipsEl = qa.querySelector('[data-chips]');
    var labEl = qa.querySelector('[data-lab]');
    var backEl = qa.querySelector('[data-back]');
    if(!chipsEl) return;
    if(backEl) backEl.hidden = (ptr === 0);
    if(labEl){ labEl.hidden = (ptr !== 0); labEl.textContent = 'Add'; }
    var seen = [], avail = {};
    data.v.forEach(function(v){
      for(var k=0;k<data.opts.length;k++){
        if(k===gi) continue;
        if(chosen[k]!=null && v.o[k]!==chosen[k]) return;
      }
      var val = v.o[gi];
      if(seen.indexOf(val)<0) seen.push(val);
      if(v.a) avail[val] = true;
    });
    var isColor = isColorOptionName(data.opts[gi]);
    chipsEl.innerHTML = seen.map(function(val){
      var dis = avail[val] ? '' : ' disabled';
      var safe = String(val).replace(/"/g,'&quot;');
      if(isColor){
        var bg = swatchColor(val);
        return '<button class="qa-chip sw" style="background:'+bg+'" data-val="'+safe+'"'+dis+' title="'+safe+'" aria-label="'+safe+'"></button>';
      }
      var short = String(val).split(' (')[0];
      return '<button class="qa-chip" data-val="'+safe+'"'+dis+'>'+short+'</button>';
    }).join('');
    chipsEl.scrollLeft = 0;
  }

  function markDone(qa){
    qa.classList.add('done');
    setTimeout(function(){
      qa.classList.remove('done');
      if(qa._d){ qa._ptr = 0; qa._chosen = buildChosenBase(qa._d.opts, qa._d.steps, qa._d.v); render(qa); }
    }, 1500);
  }

  function enhanceDressRail(root){
    root = root || document;
    ensureStyle();
    var cards = root.querySelectorAll('.pcard[href*="/products/"]:not([data-qa-live])');
    if(!cards.length) return;
    cards.forEach(function(card){
      card.setAttribute('data-qa-live', '1');
      card.removeAttribute('target');
      var m = card.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if(!m) return;
      var handle = m[1];
      var qa = card.querySelector('.qa');
      var bar = card.querySelector('.qa-bar');
      if(!qa) return;

      qa.addEventListener('click', function(e){
        var singleBtn = e.target.closest('[data-single-add]');
        if(singleBtn){
          e.preventDefault(); e.stopPropagation();
          if(!(window.YG && window.YG.addToCart)) return;
          window.YG.addToCart(singleBtn.getAttribute('data-vid'), 1).then(function(ok){
            if(!ok) return;
            qa.classList.add('done');
            setTimeout(function(){ qa.classList.remove('done'); }, 1500);
            if(window.YG && window.YG.openCart){ window.YG.openCart(); }
          });
          return;
        }
        var backBtn = e.target.closest('[data-back]');
        if(backBtn){
          e.preventDefault(); e.stopPropagation();
          if(qa._ptr > 0){ qa._ptr--; render(qa); }
          return;
        }
        var chip = e.target.closest('[data-val]');
        if(chip){
          e.preventDefault(); e.stopPropagation();
          if(chip.disabled) return;
          var data = qa._d;
          var gi = data.steps[qa._ptr];
          qa._chosen[gi] = chip.getAttribute('data-val');
          if(qa._ptr < data.steps.length - 1){ qa._ptr++; render(qa); }
          else {
            var chosen = qa._chosen;
            var match = null;
            for(var i=0;i<data.v.length;i++){
              var v = data.v[i], ok2 = v.a;
              if(ok2){ for(var k=0;k<data.opts.length;k++){ if(v.o[k]!==chosen[k]){ ok2=false; break; } } }
              if(ok2){ match = v; break; }
            }
            if(match){
              if(!(window.YG && window.YG.addToCart)) return;
              window.YG.addToCart(match.id, 1).then(function(ok){
                if(ok){ markDone(qa); if(window.YG && window.YG.openCart){ window.YG.openCart(); } }
              });
            } else if(window.YG && window.YG.toast){ window.YG.toast('That combination is unavailable'); }
          }
          return;
        }
      });

      fetch('/products/' + handle + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
        if(!p || !p.variants || !p.variants.length) return;
        var optNames = (p.options || []).map(optionName);
        var steps = [];
        for(var i=0;i<optNames.length;i++){
          var vals = {};
          p.variants.forEach(function(v){ vals[v.options[i]] = 1; });
          if(Object.keys(vals).length > 1) steps.push(i);
        }
        var data = {
          opts: optNames,
          steps: steps,
          v: p.variants.map(function(v){ return { id: v.id, a: v.available, o: v.options }; })
        };

        if(!bar) return;

        if(!steps.length){
          bar.innerHTML = '<button class="qa-btn" data-single-add data-vid="'+p.variants[0].id+'">Add to bag</button>';
          return;
        }

        qa._d = data;
        qa._ptr = 0;
        qa._chosen = buildChosenBase(data.opts, data.steps, data.v);

        bar.outerHTML = '<div class="qa-step" data-step><button class="qa-back" data-back hidden aria-label="Back">&#8592;</button><span class="qa-lab" data-lab>Add</span><div class="qa-chips" data-chips></div></div>';
        render(qa);
      }).catch(function(){});
    });
  }
  enhanceDressRail();
  document.addEventListener('yg:contentswap', function(e){ enhanceDressRail((e.detail && e.detail.root) || document); });
  window.YG = window.YG || {};
  window.YG.enhanceDressRail = enhanceDressRail;
})();
